import styled from 'styled-components';
import { Input, TextArea } from 'components/atoms/input';

export const CpInput = styled(Input)`
  border-bottom: 1px solid var(--cp-border-strong);
  background-color: white;

  font-weight: var(--cp-body-01-font-weight);
  font-size: var(--cp-body-01-font-size);
  line-height: var(--cp-body-01-line-height);
  color: var(--cp-text-primary);
  letter-spacing: var(--cp-body-01-letter-spacing);
  padding: 0 var(--cp-spacing-05);
  &::placeholder {
    color: var(--cp-black-opacity-50-hover);
  }

  &:focus {
    outline-color: var(--cp-blue-60);
    outline-width: 2px;
  }

  &:hover {
    background: var(--cp-gray-10);
  }
`;

export const CpTextArea = styled(TextArea)`
  border-bottom: 1px solid var(--cp-border-strong);
  background-color: white;

  font-weight: var(--cp-body-01-font-weight);
  font-size: var(--cp-body-01-font-size);
  line-height: var(--cp-body-01-line-height);
  color: var(--cp-text-primary);
  letter-spacing: var(--cp-body-01-letter-spacing);
  padding: var(--cp-spacing-03) var(--cp-spacing-05);

  &::placeholder {
    color: var(--cp-text-placeholder);
    margin-top: var(--cp-spacing-03);
  }

  &:focus {
    outline-color: var(--cp-blue-60);
    outline-width: 2px;
  }

  &:hover {
    background: var(--cp-gray-10);
  }
`;
